var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","color":"#75C3FF"}},[_c('div',{staticClass:"text-flex"},[_c('div',{staticStyle:{"width":"30%","height":"100%"}},[_c('data-parameter')],1),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","height":"100%"}},[_c('Eachars',{on:{"statue":_vm.upstatue}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74e4184e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Index/common/Content.vue
// module id = null
// module chunks = 